<div class="dialog-content-wrapper">
  <div class="unsave-header">
    {{'main.confirmation' | translate}}
  </div>
  <div mat-dialog-content class="m-0">
    <p class="unsave-data-text">
      <mat-icon>help</mat-icon>
      <span>{{'main.unsave_data_msg' | translate}}</span>
    </p>
  </div>

  <div mat-dialog-actions class="m-0 p-10 unsave-footer" fxLayout="row" fxLayoutAlign="space-between center">
    <button mat-button [mat-dialog-close]="'leave'">{{'main.leave' | translate}}</button>
    <button mat-button [mat-dialog-close]="'save'">{{'main.save' | translate}}</button>
  </div>
</div>
